import EditorOutput from '@/components/common/EditorOutput';
import { Container } from '@/components/ui/Grid';
import MotionHeader from '@/components/ui/MotionHeader';

const variants = {
  initial: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 1.3,
      delay: 1,
    },
  },
  hidden: { opacity: 0 },
};

const InfoPage = ({ data = {} }) => {
  return (
    <Container>
      {data.title && <MotionHeader>{data.title}</MotionHeader>}
      {data.text && <EditorOutput data={data.text} />}
    </Container>
  );
};

export default InfoPage;
